import { dynamic } from '#/utils/dynamic';

export const DynamicListingViewAdminTools = dynamic(
  () =>
    import('./ListingViewAdminTools').then((m) => ({
      default: m.ListingViewAdminTools,
    })),
  { strategy: 'always' },
);
